// extracted by mini-css-extract-plugin
export default {"statusText":"TransactionList_statusText__tRJ1d","amount":"TransactionList_amount__SNttY","positive":"TransactionList_positive__EuNFQ","negative":"TransactionList_negative__B-0yt"};